import { $isLinkNode } from '@lexical/link';
import { $createLineBreakNode, $getRoot, $isDecoratorNode, $isElementNode, $isLineBreakNode, $isParagraphNode, $isTextNode, } from 'lexical';
/**
 * Flattens a multi-paragraph Lexical root into a single paragraph, preserving
 * paragraph boundaries as line breaks.
 *
 * @throws If called outside an active Lexical editor context, such as
 * `editor.update(...)`, `editor.read(...)`, a registered command handler, a node
 * transform, or another `$`-callback.
 */
export function $flattenRootToSingleParagraph() {
    const root = $getRoot();
    if (root.getChildrenSize() <= 1)
        return;
    const children = root.getChildren();
    const first = children[0];
    if (!$isParagraphNode(first))
        return;
    for (let i = 1; i < children.length; i++) {
        const node = children[i];
        if ($isElementNode(node)) {
            first.append($createLineBreakNode());
            for (const child of node.getChildren()) {
                if ($isTextNode(child) ||
                    $isDecoratorNode(child) ||
                    $isLineBreakNode(child) ||
                    $isLinkNode(child)) {
                    first.append(child);
                }
            }
            node.remove();
        }
    }
}
//# sourceMappingURL=rootFlattening.js.map